import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Sidebar, setSidebarVisibility as setSidebarVisibilityAction } from 'react-admin';

import styles from './styles.module.scss';

// Material UI's `sm` breakpoint: below it react-admin shows the menu as a pull-out drawer.
export const PHONE_MAX_WIDTH = 599;

const isPhone = () => window.innerWidth <= PHONE_MAX_WIDTH;

/**
 * react-admin opens the menu only if the window is wide at load and never re-checks, and our app bar has
 * no button to reopen it: keep it open from tablet width up, follow resizes, and on phones close the
 * pull-out menu after navigating.
 */
function CustomSidebar({ setSidebarVisibility, location, staticContext, ...props }) {
  const [phone, setPhone] = useState(isPhone());

  useEffect(() => {
    const sync = () => {
      setPhone(isPhone());
      setSidebarVisibility(!isPhone());
    };
    sync();
    window.addEventListener('resize', sync);
    return () => window.removeEventListener('resize', sync);
  }, [setSidebarVisibility]);

  useEffect(() => {
    if (isPhone()) {
      setSidebarVisibility(false);
    }
  }, [location.pathname, setSidebarVisibility]);

  // react-admin measures the screen once per mount to pick a docked or pull-out drawer: remount it when
  // the window crosses the phone breakpoint so the right one is used.
  return <Sidebar key={phone ? 'phone' : 'wide'} className={styles.container} {...props} size={200} />;
}

export default withRouter(
  connect(
    undefined,
    { setSidebarVisibility: setSidebarVisibilityAction }
  )(CustomSidebar)
);
